import React from 'react';
import {Path} from 'react-native-svg';

import {Icon, IconProps} from './Icon';

export const GoogleIcon: React.FC<IconProps> = props => (
  <Icon stroke="none" baseHeight={36} baseWidth={36} {...props}>
    <Path
      d="M30.9602 18.3068C30.9602 17.3495 30.8743 16.429 30.7147 15.5454H18.0002V20.7675H25.2656C24.9527 22.455 24.0015 23.8847 22.5718 24.842V28.2293H26.9347C29.4875 25.879 30.9602 22.4181 30.9602 18.3068Z"
      fill="#4285F4"
    />
    <Path
      d="M17.9998 31.4999C21.6448 31.4999 24.7007 30.291 26.9344 28.2292L22.5714 24.8419C21.3625 25.6519 19.8162 26.1306 17.9998 26.1306C14.4837 26.1306 11.5075 23.7558 10.446 20.5649H5.93573V24.0626C8.15709 28.4747 12.7225 31.4999 17.9998 31.4999Z"
      fill="#34A853"
    />
    <Path
      d="M10.4463 20.565C10.1763 19.755 10.0229 18.8898 10.0229 18C10.0229 17.1103 10.1763 16.245 10.4463 15.435V11.9373H5.93609C5.02177 13.7598 4.50018 15.8216 4.50018 18C4.50018 20.1785 5.02177 22.2403 5.93609 24.0628L10.4463 20.565Z"
      fill="#FBBC05"
    />
    <Path
      d="M17.9998 9.86926C19.9819 9.86926 21.7614 10.5504 23.1605 11.8881L27.0325 8.01608C24.6946 5.83767 21.6387 4.49994 17.9998 4.49994C12.7225 4.49994 8.15709 7.52517 5.93573 11.9372L10.446 15.4349C11.5075 12.244 14.4837 9.86926 17.9998 9.86926Z"
      fill="#EA4335"
    />
  </Icon>
);
